@if (visible() && plan()) {
  <div class="modal-overlay">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h2>Zahlung abschließen</h2>
        <button class="close-btn" (click)="close()" aria-label="Schließen">&times;</button>
      </div>

      <div class="modal-body">
        <div class="plan-summary">
          <h3>{{ plan().name }}</h3>
          <div class="price">
            <span class="amount">{{ plan().priceEUR | number:'1.2-2' }}€</span>
            @if (plan().durationMonths) {
              <span class="period">für {{ plan().durationMonths }} Monat{{ (plan().durationMonths ?? 0) > 1 ? 'e' : '' }}</span>
            }
          </div>
          @if (plan().discountPercent) {
            <div class="discount">Sie sparen {{ plan().discountPercent }}%</div>
          }
        </div>

        <div class="payment-methods">
          <h3>Zahlungsmethode wählen</h3>
          <div class="methods-grid">
            <button 
              class="payment-method-btn"
              [class.selected]="paymentMethod() === 'stripe'"
              (click)="selectPaymentMethod('stripe')"
            >
              <div class="method-icon">💳</div>
              <div class="method-name">Kreditkarte</div>
              <div class="method-provider">via Stripe</div>
            </button>
            <button 
              class="payment-method-btn"
              [class.selected]="paymentMethod() === 'paypal'"
              (click)="selectPaymentMethod('paypal')"
            >
              <div class="method-icon">🅿️</div>
              <div class="method-name">PayPal</div>
              <div class="method-provider">PayPal Express</div>
            </button>
          </div>
        </div>

        @if (error()) {
          <div class="error-message">
            {{ error() }}
          </div>
        }

        <div class="terms-section">
          <!-- Acceptance Checkbox -->
          <div class="terms-checkbox">
            <label>
              <input 
                type="checkbox" 
                [checked]="termsAccepted()"
                (change)="termsAccepted.set($any($event.target).checked)"
              >
              <span>
                Ich akzeptiere die
                <a [routerLink]="['/terms']" fragment="agbs">AGBs</a>
                und bestätige, die
                <a [routerLink]="['/terms']" fragment="widerrufsrecht">Widerrufsbelehrung</a>
                gelesen zu haben.
              </span>
            </label>
          </div>

        </div>
      </div>

      <div class="modal-footer">
        <button class="btn btn-secondary" (click)="close()" [disabled]="loading()">
          Abbrechen
        </button>
        <button class="btn btn-primary" (click)="proceedToCheckout()" [disabled]="loading() || !termsAccepted()">
          @if (loading()) {
            Weiterleitung...
          } @else {
            Zur Zahlung
          }
        </button>
      </div>
    </div>
  </div>
}
